import { render, staticRenderFns } from "./SapsCompentency.vue?vue&type=template&id=a8eb23ec&scoped=true&"
import script from "./SapsCompentency.vue?vue&type=script&lang=ts&"
export * from "./SapsCompentency.vue?vue&type=script&lang=ts&"
import style0 from "./SapsCompentency.vue?vue&type=style&index=0&id=a8eb23ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8eb23ec",
  null
  
)

export default component.exports